/* unplugin-vue-components disabled */import { render } from "./ai-button.vue?vue&type=template&id=27c65491&scoped=true"
import script from "./ai-button.vue?vue&type=script&lang=js"
export * from "./ai-button.vue?vue&type=script&lang=js"

import "./ai-button.vue?vue&type=style&index=0&id=27c65491&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c65491"],['__file',"src/components/ai-chat/ai-assistant/ai-input/ai-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c65491"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c65491', __exports__)) {
    api.reload('27c65491', __exports__)
  }
  
  module.hot.accept("./ai-button.vue?vue&type=template&id=27c65491&scoped=true", () => {
    api.rerender('27c65491', render)
  })

}


export default __exports__